import { useRef, useEffect } from "react";
import { IoMdClose } from "react-icons/io";

const Modal = ({
  isOpen,
  onClose,
  children,
  showCloseButton = true,
  closeOnOverlayClick = true,
  className = "",
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "unset";
    return () => (document.body.style.overflow = "unset");
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-gray-300/50 backdrop-blur-lg dark:bg-navy-800/50"
        onClick={closeOnOverlayClick ? onClose : undefined}
      />

      {/* Modal Content */}
      <div
        ref={modalRef}
        className={`custom-scrollbar relative m-2 max-h-[90vh] w-full max-w-4xl overflow-y-auto rounded-md bg-white p-3 shadow-lg dark:bg-navy-700 md:px-6 ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        {showCloseButton && (
          <button
            onClick={onClose}
            className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-brand-500 text-white hover:bg-brand-600  dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300"
          >
            <IoMdClose />
          </button>
        )}

        {/* Modal children */}
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
